export default __webpack_public_path__ + "static/innovator-1-64e1551d864ca0615e5f412410a1212e.png";